export default function reCaptchaProtect(callback, form) {
    function executeRecaptcha() {
        const recaptchaInputHtml = '<input type="hidden" name="g-recaptcha-response" id="g-recaptcha-response" />';

        if (form && form.length) {
            const recaptchaElement = findRecaptchaElement();

            if (! recaptchaElement) {
                console.error('Recaptcha element not found in the form');

                if (window.jQuery && form instanceof jQuery) {
                    form.append(recaptchaInputHtml);
                } else {
                    form.insertAdjacentHTML('afterbegin', recaptchaInputHtml);
                }
            }
        } else {
            form = document.querySelector('form');

            if (! form) {
                console.error('No form found in the document');
                return;
            }

            const recaptchaElement = findRecaptchaElement();

            if (! recaptchaElement) {
                console.warn('Recaptcha element not found in the form');
                console.warn('Using native JavaScript to insert recaptcha input');
                form.insertAdjacentHTML('afterbegin', recaptchaInputHtml);
            }
        }

        grecaptcha.ready(async function() {
            grecaptcha.execute(reCaptchaSiteKey, { action: 'submit' })
                .then(function(token) {
                    let formField = findRecaptchaElement();

                    // If not found, try to find again (in case it was just inserted)
                    if (!formField) {
                        formField = findRecaptchaElement();
                    }
                    if (!formField) {
                        console.warn('Recaptcha element not found');
                        return;
                    }

                    // Set value for both jQuery and native elements
                    if (window.jQuery && formField instanceof jQuery) {
                        formField.val(token);
                    } else if (formField instanceof Element) {
                        formField.value = token;
                    }

                    callback();
                });
        });
    }

    function findRecaptchaElement() {
        const inputKey = '#g-recaptcha-response';
        let grecaptchaResponse = null;

        if (form && form.length) {
            grecaptchaResponse = $(form).find(inputKey);
            // If using jQuery, return the DOM element if found
            if (grecaptchaResponse.length) {
                return grecaptchaResponse;
            } else {
                return null;
            }
        } else {
            grecaptchaResponse = document.querySelector(inputKey);
        }

        return grecaptchaResponse;
    }

    if (typeof grecaptcha !== 'undefined') {
        executeRecaptcha();
    } else {
        const script = document.querySelector('#g-recaptcha-script');
        if (script) {
            script.addEventListener('load', executeRecaptcha);
        }
    }
}

window.reCaptchaProtect = reCaptchaProtect;